const MENU_WIDTH = 280;
const MENU_HEIGHT = 320;
const VIEWPORT_MARGIN = 8;

export type DialMenuPosition = { top: number; left: number; width: number };

/** Fixed position under the trigger, flipped above when the panel would clip. */
export function dialMenuPosition(anchor: HTMLElement): DialMenuPosition {
  const rect = anchor.getBoundingClientRect();
  let left = rect.left;
  if (left + MENU_WIDTH > window.innerWidth - VIEWPORT_MARGIN) {
    left = Math.max(VIEWPORT_MARGIN, window.innerWidth - MENU_WIDTH - VIEWPORT_MARGIN);
  }
  const spaceBelow = window.innerHeight - rect.bottom;
  const top =
    spaceBelow < MENU_HEIGHT && rect.top > spaceBelow
      ? Math.max(VIEWPORT_MARGIN, rect.top - MENU_HEIGHT - 4)
      : rect.bottom + 4;
  return { top, left, width: MENU_WIDTH };
}

/**
 * Menu host inside the widget shadow root so Emotion styles apply and the
 * transcript overflow does not clip the list. Document body outside shadow DOM.
 */
export function dialMenuHost(anchor: HTMLElement | null): HTMLElement | null {
  if (!anchor || typeof document === 'undefined') return null;
  const root = anchor.getRootNode();
  if (root instanceof ShadowRoot) {
    const existing = root.querySelector('[data-intake-dial-host]');
    if (existing instanceof HTMLElement) return existing;
    const host = document.createElement('div');
    host.dataset.intakeDialHost = '';
    root.appendChild(host);
    return host;
  }
  return document.body;
}
